// extracted by mini-css-extract-plugin
export default {"container":"yN-z","topReviewHeading":"zN-z","criticalReview":"AN-z","favorableReview":"BN-z","vsSeparator":"CN-z"};